module.exports = " <div class=\"day text-center\" :class=\"{ 'active': active, 'next': next, 'previous': previous }\"> <h4 class=\"header serif italic\">On this day in <strong>{{ year }}</strong></h4> <div class=\"content sans-serif\"> {{{ day.body.value }}} </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./site/sites/all/themes/custom/abr_theme/js/race-schedule/components/DayInRacing.vue
 ** module id = 394
 ** module chunks = 1
 **/